<script>
	import { isPowerValue } from './types';
	import FixedScore from './footer/FixedScore.svelte';
	import FocusScore from './footer/FocusScore.svelte';
	import WildFocusScore from './footer/WildFocusScore.svelte';
	import { res } from '../stores';
	import "./shared.css";
    import DualScore from './footer/DualScore.svelte';

	export let id;
	export let position = undefined;
	export let score = undefined;
	export let isDuplicate = false;

	function isKnownDeck(id){
		let c = $res.cardsByRef[id];
		let excludedDecks = ['Common', 'Locations', 'Encounters', 'Rewards']
		if(!c || !c.deck) return false;
		if(!excludedDecks.includes(c.deck)) return `assets/decks/deck-${c.deck.toLowerCase()}.svg`;
		return false;
	}
</script>

<div class="footer">
	{#if isKnownDeck(id)}
		<img src={isKnownDeck(id)} alt={id} />
	{/if}
	<div class="footer-side">
		<div class="id-label font-heading">{id}</div>
	</div>
	{#if isDuplicate}
		<div class="duplicate-container">
			<div class="d1" />
			<div class="d2" />
		</div>
	{/if}
	<div class="position-container">
		{#if position}
			<div>
				<span class="font-heading">{position.toUpperCase()}</span>
			</div>
		{/if}
	</div>
	<div class="footer-side">
		{#if score && isPowerValue(score)}
			{#if score === 'wild'}
				<WildFocusScore />
			{:else}
				<FocusScore {score} />
			{/if}
		{:else if score && score.includes('/')}
			<DualScore {score} />
		{:else if score}
			<FixedScore {score} />
		{/if}
	</div>
</div>

<style lang="scss">
	.footer {
		position: relative;
		height: calc(var(--height) / 13.82759); /* 29px; */
		align-items: center;
		& > img {
			position: absolute;
			bottom: calc(0px - var(--height) / 40.1); //-10px;
			left: 3em; // ??
			z-index: 20;
			height: calc(var(--height) / 10.025);//40px;
		}
	}
	.footer-side {
		width: 25%;
		height: 100%;
		align-items: center;
		position: relative;
		z-index: 5;
	}
	.position-container {
		flex-grow: 1;
		align-items: center;
		justify-content: center;
		& div {
			background-color: rgba(0, 0, 0, 0.5);
			padding: calc(var(--height) / 200.5) calc(var(--width) / 23.917); //2px 12px;
			border-radius: calc(var(--height) / 50.125) //8px;
		}
		& span {
			color: white;
			font-size: calc(var(--height) / 33.417); //12px;
			line-height: 1;
			margin-top: -1px;
		}
	}
	.id-label {
		height: fit-content;
		width: 100%;
		padding: 1px 0 1px 1.5em;
		color: white;
		font-size: calc(var(--width) / 31.889); //9px;
		font-weight: light;
		background-color: black;
		border-radius: 0 calc(var(--height) / 50.125) calc(var(--height) / 50.125) 0;//0 8px 8px 0;
		align-items: center;
	}
	.duplicate-container {
		width: calc(var(--width) / 19.133); //15px;
		height: calc(var(--height) / 26.733); //15px;
		margin-left: 0.5em;
		position: relative;
	}
	.d1 {
		box-sizing: border-box;
		border: 2px solid #79c;
		border-radius: calc(var(--height) / 200.5); //2px;
		width: calc(var(--width) / 28.7); //10px;
		height: calc(var(--height) / 40.1); //10px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}
	.d2 {
		background-color: #79c;
		border-radius: calc(var(--height) / 200.5); //2px;
		width: calc(var(--width) / 28.7); //10px;
		height: calc(var(--height) / 40.1); //10px;10px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 3;
	}
</style>
